import { useEffect, useState, useRef, useCallback } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

interface StudentData {
  id: number;
  image: string;
  subject?: string;
  university?: string;
  school: string;
  name: string;
  shortQuote?: string;
  fullTestimonial?: string;
  orderIndex?: number;
  youtubeUrl?: string;
}

const scholarshipStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/289e5e3618039af725a9cc543a40dc77.png',
    university: '26학년도 고려대 교육학과 합격',
    school: '송현고3',
    name: '박강현',
    shortQuote: '"고2때 미래인재학원을 다니게 된 것은 행운이었습니다"',
    fullTestimonial: '고2때 미래인재학원을 다니게 된 것은 행운이었습니다. 처음에는 성적이 잘 오르지 않아 걱정이 많았지만, 선생님들의 꼼꼼한 지도와 체계적인 커리큘럼 덕분에 점차 자신감을 갖게 되었습니다. 특히 수학과 영어 과목에서 큰 폭으로 성적이 올랐고, 내신 관리뿐만 아니라 수능 대비까지 완벽하게 준비할 수 있었습니다. 선생님들께서 항상 개인별 맞춤 상담을 해주셔서 진로 방향도 명확하게 잡을 수 있었고, 결국 꿈에 그리던 고려대학교 교육학과에 합격할 수 있었습니다. 미래인재학원에서 보낸 시간이 제 인생의 터닝포인트였다고 자신 있게 말할 수 있습니다.',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d9a09a24238313521905252e8c89cf7f.png',
    university: '26학년도 고려대 기계공학부 합격',
    school: '옥빛고3',
    name: '최보근',
    shortQuote: '"미래인재 덕분에 좋은 결과 낼 수 있었다고 생각합니다"',
    fullTestimonial: '수능 최저 기준을 맞추는 것이 가장 큰 고민이었는데, 미래인재학원에서 끝까지 국어, 영어, 수학을 체계적으로 준비할 수 있었습니다. 선생님들의 꼼꼼한 지도와 매일 스터디카페에서 문제를 풀며 실력을 쌓아갔습니다. 국어와 영어도 수능 최저에 맞춰 전략적으로 공부할 수 있도록 도와주셨고, 모의고사 때마다 부족한 부분을 정확히 짚어주셔서 효율적으로 성적을 올릴 수 있었습니다. 결국 수능에서 목표 등급을 달성하여 수능 최저를 맞출 수 있었고, 고려대 기계공학부에 합격하는 기쁨을 누렸습니다. 끝까지 포기하지 않고 함께해주신 미래인재학원 덕분에 좋은 결과를 낼 수 있었다고 생각합니다.',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8f8bbfbd23714ff065caf2b61a3e5dd1.png',
    university: '26학년도 연세대 의예과 합격',
    school: '동두천고3',
    name: '강지호',
    shortQuote: '"중1 부터 고3 까지 미래인재학원만 다녔습니다"',
    fullTestimonial: '중1 부터 고3 까지 미래인재학원만 다녔습니다. 의대를 목표로 하면서 모든 과목에서 최상위권을 유지해야 한다는 부담감이 컸지만, 미래인재학원의 체계적인 시스템 덕분에 효율적으로 공부할 수 있었습니다. 과학 심화 수업과 수학 고난도 문제 풀이가 특히 도움이 되었고, 선생님들의 열정적인 수업 덕분에 매 시험마다 좋은 성적을 유지할 수 있었습니다. 수시와 정시를 동시에 준비하는 과정에서도 전략적인 조언을 많이 받았고, 최종적으로 연세대 의예과에 합격하는 기쁨을 누릴 수 있었습니다.',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/179b39ef55221ab5e1cf923df5e941bb.png',
    university: '26학년도 고려대 전기전자공학부 합격',
    school: '한빛누리고3',
    name: '김강윤',
    shortQuote: '"소름 끼칠 정도로, 학교 적중 문제를 많이 맞춰주셔서, 시험때 도움이 많이 되었습니다"',
    fullTestimonial: '소름 끼칠 정도로, 학교 적중 문제를 많이 맞춰주셔서, 시험때 도움이 많이 되었습니다. 한빛누리고에서 내신 관리를 하면서 동시에 수능 준비를 하는 것이 쉽지 않았는데, 미래인재학원에서 두 가지를 병행할 수 있는 최적의 학습 플랜을 짜주셨습니다. 내신 기간에는 학교 시험에 집중하고, 그 외 기간에는 수능 대비에 몰두하는 전략이 정말 효과적이었습니다. 특히 수학과 과학 선생님들의 깊이 있는 수업이 큰 도움이 되었고, 덕분에 수능에서도 좋은 성적을 거두어 고려대 전기전자공학부에 합격할 수 있었습니다.',
    youtubeUrl: 'https://youtube.com/shorts/dTjgYVeK0UY?feature=share',
  },
];

const refundStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d9a09a24238313521905252e8c89cf7f.png',
    subject: '26년도 수능 수학(확통) 2등급',
    school: '옥빛고3',
    name: '최보근',
    shortQuote: '"다양한 문제 풀이와 심화적인 해설이 좋았습니다. 소규모 수업 형식을 끝까지 유지해주시면서, 수능을 준비할 수 있던 것도 좋았습니다"',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/760538bc423ea7df896f1f552a834870.png',
    subject: '26학년도 수능 수학(확통) 1등급',
    school: '옥빛고3',
    name: '이윤성',
    shortQuote: '"수능 준비가 막막할 때 큰 도움이 됐습니다"',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/179b39ef55221ab5e1cf923df5e941bb.png',
    subject: '26학년도 수능 수학(미적) 1등급',
    school: '한빛누리고3',
    name: '김강윤',
    shortQuote: '"단순히 암기적인 테크닉보다 발상하는 방식을 훈련 시켜 주셔서, 수학 능력을 기를 수 있었습니다"',
    youtubeUrl: 'https://youtube.com/shorts/dTjgYVeK0UY?feature=share',
  },
];

const discountStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/cb6360e892eacaf36376ecd73a4002ab.png',
    subject: '25년 옥빛고1 1,2학기 전 과목 1등급',
    school: '옥빛고1',
    name: '김노아',
    shortQuote: '"단체 수업 인데도, 선생님이 한 명씩 세삼하게 봐주셔서 일대일 수업처럼 느껴져셔 좋았습니다"',
    youtubeUrl: 'https://youtube.com/shorts/7yKBTeigB_I?feature=share',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/db77dbd65f4b7d5bf8981467ef5ef670.png',
    subject: '25년 옥빛고1 1,2학기 전 과목 1등급',
    school: '옥빛고1',
    name: '김소람',
    shortQuote: '"매달 치뤄지는 월간고사 통해 제 실력을 점검하고, 내신 시험을 위한 재정비 시간을 가질 수 있어 좋았습니다"',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/fcacbe7b8613b783ef548940f5c2170c.png',
    subject: '25년 옥정고2 1학기 전 과목 1등급',
    school: '옥정고2',
    name: '최예빈',
    shortQuote: '"언제든 질의응답할 수 있는 환경에서 공부해서 시험을 준비할 때 불안함을 덜어주셨습니다! 그래서 학원에 더 크게 의존했던 것 같습니다"',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/6b3d13261f2c37ce5c114891cba9ee6a.png',
    subject: '25년 옥빛고1 1학기 전 과목 1등급',
    school: '옥빛고1',
    name: '김지한',
    shortQuote: '"대형 학원임에도 불구하고, 촘촘하게 소규모로 반이 나뉘어져 있어서 놀랐습니다"',
  },
  {
    id: 6,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/72c5df7d25ba60d9c15a3eb05f5aa93b.png',
    subject: '25년 옥빛고1 2학기 전 과목 1등',
    school: '옥빛고1',
    name: '박소윤',
    shortQuote: '"학생들을 위해 선생님들이 항상 열정적으로 가르쳐주십니다"',
  },
  {
    id: 7,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/92b2205c30d0187233b4c1b233ad999b.png',
    subject: '25년 동두천고1 1,2학기 전 과목 1등',
    school: '동두천고1',
    name: '김동주',
    shortQuote: '"학원에 다니며서 매일 꾸준히 공부하는 습관이 생겼고, 그 덕분에 성적도 자연스럽게 올라 정말 큰 도움이 되었습니다!"',
    youtubeUrl: 'https://youtube.com/shorts/LV48b0LJfH4?feature=share',
  },
  {
    id: 8,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/85bf2b2334d4b2ba4978ca01eb50164a.png',
    subject: '25년 한빛누리고1 1,2학기 전 과목 1등',
    school: '한빛누리고1',
    name: '홍단샘',
    shortQuote: '"미래인재학원만이 가지는 체계적인 관리와 시스템은 정말 큰 장점이라고 생각합니다. 개인의 의지만 충분하다면 성적을 올리는 데 있어서 큰 도움이 되는 거 같습니다"',
    youtubeUrl: 'https://youtube.com/shorts/1Rt6sN53MMw',
  },
  {
    id: 9,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/09313cf8b862ddbaf51f8bdfb68d9273.png',
    subject: '25년 한빛누리고1 1,2학기 전 과목 1등',
    school: '한빛누리고1',
    name: '강지민',
    shortQuote: '"학원에서는 단순한 문제풀이를 넘어 성적을 올리는 방법론을 제시해주셔서 좋았습니다"',
  },
  {
    id: 10,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/2611d24f1b0477e74ea7bc4da78629aa.png',
    subject: '25년 중앙고1 1,2학기 전 과목 1등',
    school: '중앙고1',
    name: '김영준',
    shortQuote: '"미래인재학원을 다니면서 실력도 오르고, 자신감도 커진 게 제일 좋았다"',
    youtubeUrl: 'https://youtube.com/shorts/I5B_xM3nfUI?feature=share',
  },
  {
    id: 11,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/fb742e19b5e2aa20a31977609498f1ea.jpeg',
    subject: '25년 옥빛고1 2학기 전 과목 1등',
    school: '옥빛고1',
    name: '이소현',
    shortQuote: '',
  },
];

const topStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/0adcf624f35b37b864ca34d171c466a1.png',
    subject: '25년 옥빛고1 2학기 수학 전교 1등',
    school: '옥빛고1',
    name: '이준석',
    shortQuote: '"수업시간에 수업을 녹화해주시기 때문에, 나중에 부족한 부분을 영상을 통해 보완할 수 있어서 크게 도움이 되었습니다"',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d9a3ea58263230f87b0cbc66318c7d4c.png',
    subject: '25년 옥정고1 1학기 영어 전교 1등',
    school: '옥정고1',
    name: '장석규',
    shortQuote: '숙제 검사 시간에 암기 테스트를 통해 부족한 부분을 보완할 수 있어서 좋았습니다!',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ab8cdce927be10f9489fa75cba937aab.png',
    subject: '25년 옥정고1 1학기 영어 전교 1등',
    school: '옥정고1',
    name: '황영웅',
    shortQuote: '많은 재원생 수에도 불구하고 선생님들의 열정적이고 꼼꼼한 수업이 좋았습니다.',
    youtubeUrl: 'https://youtube.com/shorts/LpXkyHMNMcw?feature=share',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ad2017a5770c236ea78ae2fe42f28958.png',
    subject: '25년 옥정고2 1학기 수학 전교 1등',
    school: '옥정고2',
    name: '최예빈',
    shortQuote: '"언제든 질의응답할 수 있는 환경에서 공부해서 시험을 준비할 때 불안함을 덜어주셨습니다! 그래서 학원에 더 크게 의존했던 것 같습니다"',
  },
  {
    id: 5,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/95b61329cbd309af68254264ceb8c77b.png',
    subject: '25년 옥빛고1 1학기 영어 전교 1등',
    school: '옥빛고1',
    name: '장윤서',
    shortQuote: '"꼼꼼한 내신 분석 설명과 주제, 요약본, 동반의어등 관련 자료집이 도움이 많이 되었습니다"',
    youtubeUrl: 'https://youtube.com/shorts/qlnV_bmAImk?feature=share',
  },
  {
    id: 6,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/6b3d13261f2c37ce5c114891cba9ee6a.png',
    subject: '25년 옥빛고1 1학기 영어 전교 1등',
    school: '옥빛고1',
    name: '김지한',
    shortQuote: '"대형 학원임에도 불구하고, 촘촘하게 소규모로 반이 나뉘어져 있어서 놀랐습니다"',
  },
  {
    id: 7,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/2e7031bbf1a3c4c4063aa19e6938b5a6.png',
    subject: '25년 옥빛고2 2학기 수학 전교 1등',
    school: '옥빛고2',
    name: '안태민',
    shortQuote: '"개념을 공식 암기가 아닌, 원리 중심으로 설명해 주셔서 응용문제 풀이에 큰 도움이 되었습니다"',
  },
  {
    id: 8,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e40dbeb265eebc86990a69b983a1c1e1.png',
    subject: '25년 중앙고1 2학기 수학 전교 1등',
    school: '중앙고1',
    name: '권윤택',
    shortQuote: '"학원에 다니며 학습 계획을 꾸준히 유지하고 스스로 공부하는 습관을 기를 수 있어서 좋았습니다"',
  },
  {
    id: 9,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/48ecbfed6bfe379e3c4918fa2c8e3f4c.png',
    subject: '25년 신흥고1 2학기 수학 전교 1등',
    school: '신흥고1',
    name: '문한빈',
    shortQuote: '"미래인재학원에서 체계적인 개념 설명과 문제풀이 훈련을 통해서 성적이 향상되었고, 자기 주도 학습 습관까지 기를 수 있어서 매우 만족스럽습니다"',
  },
  {
    id: 10,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/232714f07cf136cd9380518a62191f8a.png',
    subject: '25년 신흥고1 2학기 영어 전교 1등',
    school: '신흥고1',
    name: '김민채',
    shortQuote: '체계적인 수업 덕분에 수학과 영어 실력이 안정적으로 향상됐습니다. 또 규칙적인 학습 환경이 성적 향상에 도움이 됐습니다.',
  },
  {
    id: 11,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e5fb6352b0bb880352459b9c0a3bad95.png',
    subject: '25년 옥빛고1 2학기 수학 전교 1등',
    school: '옥빛고1',
    name: '송지후',
    shortQuote: '"미래인재학원의 보충 시스템이 저를 전교 1등으로 만들어 준 것 같습니다. 너무 보람차고 더욱 공부에 대한 의지가 강해진 것 같습니다"',
  },
  {
    id: 12,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/62b6cebbda4ac71a9c25156721dc7fb3.png',
    subject: '25년 옥빛고1 2학기 영어 전교 1등',
    school: '옥빛고1',
    name: '정준혁',
    shortQuote: '"학원 내신 대비 모의고사가 실제 시험과 비슷해 실전 감각을 기르는 데 큰 도움이 되었고, 피드백을 통해 부족한 부분을 바로 보완할 수 있었습니다. 이런 반복 연습이 좋은 결과로 이어졌다고 생각합니다."',
  },
  {
    id: 13,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/c2aa57a34dac73f09da3bfb11638ec36.png',
    subject: '25년 옥빛고1 2학기 수학 전교 1등',
    school: '옥빛고1',
    name: '서가은',
    shortQuote: '"좋은 성적 받을 수 있었습니다. 학원비가 아깝지 않은 학원입니다."',
  },
  {
    id: 14,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8b80ed0bde2ce9dad10814a80ccc028f.png',
    subject: '25년 덕계고1 2학기 영어 전교 1등',
    school: '덕계고1',
    name: '신민경',
    shortQuote: '"학교별로, 수준별로, 학생별로 각각 부족하고 필요한 것을 채울 수 있는 수업과 숙제를 제공해 주는 시스템으로 실력을 체계적으로 쌓을 수 있었습니다."',
  },
  {
    id: 16,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/a49d97bea743677e25d99251da0f7ace.png',
    subject: '25년 옥빛고1 2학기 영어 과목 1등',
    school: '옥빛고1',
    name: '김해윰',
    shortQuote: '학원에서 제공해준 학습자료로 개념을 정리할 수 있었고, 담당 선생님께서 유형별로 접근방법을 알려주셔서 도움이 되었습니다.',
  },
  {
    id: 17,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/72fc37a6e891089e95fa601eace7c8f3.png',
    subject: '25년 옥빛고1 1학기 과학 전교 1등',
    school: '옥빛고1',
    name: '임재준',
    shortQuote: '당일 학원 수업에 참여하지 못해도 수업 녹화 영상을 통한 보충으로 수업 진도를 쉽게 따라갈 수 있어 좋았습니다.',
    youtubeUrl: 'https://youtube.com/shorts/2bZhd_22vCE?feature=share',
  },
];

const honorStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4aedfdd997feead24487a35065c0c872.png',
    subject: '25년 옥정중 졸업 내신 199',
    school: '옥정중3',
    name: '임승현',
    shortQuote: '',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/f096080cea02b1932c48c01baf979f7d.png',
    subject: '25년 옥정중 졸업 내신 199',
    school: '옥정중3',
    name: '이효주',
    shortQuote: '시험기간에 문제를 다양하게 풀어볼 수 있어서 공부하는데 도움이 많이 됐어요.',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/3801327c8c2034c2743a2e38cd56fbd5.png',
    subject: '25년 옥정중 졸업 내신 199',
    school: '옥정중3',
    name: '김소은',
    shortQuote: '"정규 수업 외에도 자유롭게 질문할 수 있어서 좋았고, 다양한 자료도 큰 도움이 되었습니다"',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/f624a7a383228fe3f43cb3fe805a078d.png',
    subject: '25년 옥정중 졸업 내신 199',
    school: '옥정중3',
    name: '김민서',
    shortQuote: '"꼼꼼한 관리와 내신 대비, 모의고사 준비까지 미리 시켜주셔서, 실력을 올릴 수 있게 되어서 만족스러워요"',
  },
  {
    id: 5,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/88f5ee9be30a2c6e336fac180627b7fb.png',
    subject: '25년 민락중 졸업 내신 199',
    school: '민락중3',
    name: '유영은',
    shortQuote: '"체계적인 학원 시스템 덕분에 효율적으로 공부할 수 있어 좋습니다"',
  },
  {
    id: 6,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/525bc97d54faac8fe86186d3dbe96154.png',
    subject: '25년 옥빛중 졸업 내신 199',
    school: '옥빛중3',
    name: '이도훈',
    shortQuote: '시험대비를 확실히 시켜줘서 좋습니다. 덕분에 시험때 다른과목에 시간을 많이 투자 할 수 있었습니다',
  },
];

const perfectStudents = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/c56d5b6f45a936b672c26cbdef8ab905.png',
    subject: '25년 1학기 전 과목 100점',
    school: '옥빛중2',
    name: '이도찬',
    shortQuote: '',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4d947415dbabede857ce47f9e6685960.png',
    subject: '25년 1학기 전 과목 100점',
    school: '신흥중3',
    name: '이시호',
    shortQuote: '',
    youtubeUrl: 'https://youtube.com/shorts/j0YNN26uItc?feature=share',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4aedfdd997feead24487a35065c0c872.png',
    subject: '25년 1학기 전 과목 100점',
    school: '옥정중3',
    name: '임승현',
    shortQuote: '',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce2a9823208615ae4b8712701e804eab.png',
    subject: '25년 1학기 전 과목 100점',
    school: '동여중3',
    name: '양지원',
    shortQuote: '"미래인재의 체계적인 관리와 적은반 인원수로 인해 더 효과적으로 수학을 공부할 수 있어서 좋았습니다!"',
  },
];

const perfect100Students = [
  {
    name: '이시호',
    school: '한빛누리고',
    grade: '1학년',
    subject: '수학',
    score: '100점',
    image: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4d947415dbabede857ce47f9e6685960.png',
    youtubeId: 'Ql-Ql-Ql-Ql',
  },
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/c56d5b6f45a936b672c26cbdef8ab905.png',
    subject: '25년 1학기 전 과목 100점',
    school: '옥빛중2',
    name: '이도찬',
    shortQuote: '',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/432c511cf5c04d5eceb645115bbad56e.png',
    subject: '25년 1학기 전 과목 100점',
    school: '신흥중3',
    name: '이시호',
    shortQuote: '',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4aedfdd997feead24487a35065c0c872.png',
    subject: '25년 1학기 전 과목 100점',
    school: '옥정중3',
    name: '임승현',
    shortQuote: '',
  },
];

const perfect100Sections = [
  {
    id: 'middle',
    title: '중학생 전 과목 100점',
    description: '다음 달 수강하는 교육비 전액 면제',
    noteIcon: 'ri-trophy-line',
    noteText: '다음 달 수강하는 과목은 전 달과 무관하게 자유롭게 선택할 수 있습니다.',
    students: [
      {
        name: '김○○',
        school: '○○중학교',
        grade: '중1',
        achievement: '전 과목 100점',
        period: '2024년 1학기 중간고사',
        image: 'https://public.readdy.ai/ai/img_res/06aabbf2ba68595a5efee2d3f0d5dd6c.jpg',
      },
      {
        name: '이○○',
        school: '○○중학교',
        grade: '중2',
        achievement: '전 과목 100점',
        period: '2024년 1학기 기말고사',
        image: 'https://readdy.ai/api/search-image?query=A%20confident%20Korean%20middle%20school%20student%20in%20neat%20uniform%20displaying%20perfect%20test%20scores%20with%20a%20bright%20smile%20in%20a%20well-lit%20modern%20study%20environment%20with%20clean%20white%20walls%20and%20simple%20background%20showing%20academic%20excellence%20and%20happiness&width=400&height=500&seq=perfect100-middle-2&orientation=portrait',
      },
      {
        name: '박○○',
        school: '○○중학교',
        grade: '중3',
        achievement: '전 과목 100점',
        period: '2024년 2학기 중간고사',
        image: 'https://readdy.ai/api/search-image?query=A%20successful%20Korean%20middle%20school%20student%20in%20school%20uniform%20holding%20top-grade%20test%20results%20with%20a%20confident%20and%20happy%20expression%20in%20a%20bright%20modern%20classroom%20with%20minimalist%20clean%20background%20and%20professional%20lighting%20showing%20outstanding%20performance&width=400&height=500&seq=perfect100-middle-3&orientation=portrait',
      },
    ],
  },
  {
    id: 'high',
    title: '고등학생 전 과목 1등급',
    description: '다음 달 수강하는 교육비 전액 면제',
    noteIcon: 'ri-percent-line',
    noteText: '단, 수능 수업을 끝까지 수강하는 학생만 가능합니다',
    students: [
      {
        name: '최○○',
        school: '○○고등학교',
        grade: '고1',
        achievement: '전 과목 1등급',
        period: '2024년 1학기 중간고사',
        image: 'https://readdy.ai/api/search-image?query=A%20determined%20Korean%20high%20school%20student%20in%20formal%20uniform%20proudly%20showing%20grade%201%20report%20card%20with%20a%20confident%20expression%20in%20a%20modern%20bright%20study%20room%20with%20clean%20minimalist%20background%20and%20professional%20lighting%20representing%20top%20academic%20achievement&width=400&height=500&seq=perfect100-high-1&orientation=portrait',
      },
      {
        name: '정○○',
        school: '○○고등학교',
        grade: '고2',
        achievement: '전 과목 1등급',
        period: '2024년 1학기 기말고사',
        image: 'https://readdy.ai/api/search-image?query=A%20focused%20Korean%20high%20school%20student%20in%20neat%20school%20uniform%20displaying%20excellent%20grade%20report%20with%20a%20proud%20smile%20in%20a%20well-lit%20contemporary%20classroom%20with%20simple%20white%20background%20and%20soft%20shadows%20celebrating%20academic%20excellence&width=400&height=500&seq=perfect100-high-2&orientation=portrait',
      },
      {
        name: '강○○',
        school: '○○고등학교',
        grade: '고3',
        achievement: '전 과목 1등급',
        period: '2024년 2학기 중간고사',
        image: 'https://readdy.ai/api/search-image?query=A%20successful%20Korean%20high%20school%20senior%20in%20formal%20uniform%20holding%20top-grade%20test%20results%20with%20a%20confident%20and%20happy%20expression%20in%20a%20bright%20modern%20study%20space%20with%20minimalist%20clean%20background%20and%20professional%20lighting%20showing%20outstanding%20performance&width=400&height=500&seq=perfect100-high-3&orientation=portrait',
      },
    ],
  },
];

interface SectionData {
  id: string;
  tag: string;
  title: JSX.Element;
  description: JSX.Element;
  noteIcon: string;
  noteText: string;
  students: {
    id: number;
    image: string;
    subject?: string;
    university?: string;
    school: string;
    name: string;
  }[];
  labelKey: 'university' | 'subject';
  number: string;
}

const sections: SectionData[] = [
  {
    id: 'scholarship-100',
    tag: 'SCHOLARSHIP',
    number: '01',
    title: (
      <>
        장학금<br />
        <span className="text-yellow-400">100만원</span> 지급
      </>
    ),
    description: (
      <>
        <strong className="text-white">
          서울대, 연세대, 고려대, 의대, 약대,
          <br className="hidden md:block" />
          치대, 한의대, 수의대, 카이스트, 포항공대
        </strong>
        <br />
        <span className="text-yellow-400 font-semibold">
          합격 시 100만원 지급
        </span>
      </>
    ),
    noteIcon: 'ri-trophy-line',
    noteText: '3학년 1학기까지 최종 수강한 재원생만을 대상으로 합니다',
    students: scholarshipStudents,
    labelKey: 'university',
  },
  {
    id: 'refund-50',
    tag: 'REFUND',
    number: '02',
    title: (
      <>
        수능 1등급<br />
        교육비 <span className="text-yellow-400">50%</span> 환급
      </>
    ),
    description: (
      <strong className="text-white">
        수능에서 1등급을 받는 경우,
        <br className="hidden md:block" />
        수능 최저 기간에 수강한 총 교육비의 50% 환급
        <br />
        <span className="text-neutral-300 font-normal text-base">(수능에서 2등급 받는 경우 30% 환급)</span>
      </strong>
    ),
    noteIcon: 'ri-percent-line',
    noteText: '단, 수능 수업을 끝까지 수강하는 학생만 가능합니다',
    students: refundStudents,
    labelKey: 'subject',
  },
  {
    id: 'discount-50',
    tag: 'DISCOUNT',
    number: '03',
    title: (
      <>
        전 과목 1등급<br />
        교육비 <span className="text-yellow-400">50%</span> 할인
      </>
    ),
    description: (
      <strong className="text-white">
        다음 학기 시험까지 수강하는
        <br className="hidden md:block" />
        전체 교육비의 50% 할인
      </strong>
    ),
    noteIcon: 'ri-price-tag-3-line',
    noteText: '중간고사인 경우, 지필 등수로 1등급 유지 시 기말고사까지 혜택이 연장됩니다',
    students: discountStudents,
    labelKey: 'subject',
  },
  {
    id: 'top-free',
    tag: 'FREE',
    number: '04',
    title: (
      <span className="text-2xl md:text-4xl lg:text-5xl">
        과목 전교 1등 달성 시,<br />
        해당 과목 다음 달 <span className="text-yellow-400">무료</span> 수강
      </span>
    ),
    description: (
      <strong className="text-white">
        전교 1등 달성한 과목은 다음 달 교육비에서,
        <br className="hidden md:block" />
        해당 과목 교육비만큼 차감
      </strong>
    ),
    noteIcon: 'ri-gift-line',
    noteText: '단, 다음 달 수강하지 않는 경우 차감하지 않습니다',
    students: topStudents,
    labelKey: 'subject',
  },
  {
    id: 'honor-199',
    tag: 'HONOR',
    number: '05',
    title: (
      <>
        중3 최종 내신 199<br />
        교육비 <span className="text-yellow-400">50%</span> 할인
      </>
    ),
    description: (
      <strong className="text-white">
        고1 1학기 중간고사 시험까지 수강하는 전체 교육비의 50% 할인
      </strong>
    ),
    noteIcon: 'ri-medal-line',
    noteText: '중간고사 지필 점수 등수로 전 과목 1등급 유지 시 기말고사까지 혜택이 연장됩니다',
    students: honorStudents,
    labelKey: 'subject',
  },
  {
    id: 'perfect-100',
    tag: 'PERFECT',
    number: '06',
    title: (
      <>
        중학생 전 과목 100점<br />
        다음 달 교육비 <span className="text-yellow-400">전액 면제</span>
      </>
    ),
    description: (
      <strong className="text-white">
        다음 달 수강하는 교육비
        <br className="hidden md:block" />
        전액 면제
      </strong>
    ),
    noteIcon: 'ri-star-line',
    noteText: '단, 다음 달 수강하지 않는 경우 차감하지 않습니다',
    students: perfectStudents,
    labelKey: 'subject',
  },
];

interface StudentWithTestimonial {
  id: number;
  image: string;
  university?: string;
  subject?: string;
  school: string;
  name: string;
  shortQuote?: string;
  fullTestimonial?: string;
  orderIndex?: number;
  youtubeUrl?: string;
}

function YouTubeModal({
  isOpen,
  onClose,
  youtubeUrl,
  studentName,
}: {
  isOpen: boolean;
  onClose: () => void;
  youtubeUrl: string;
  studentName: string;
}) {
  if (!isOpen || !youtubeUrl) return null;

  // YouTube URL에서 영상 ID 추출
  let videoId = '';
  try {
    const url = new URL(youtubeUrl);
    if (url.pathname.includes('/shorts/')) {
      videoId = url.pathname.split('/shorts/')[1]?.split('?')[0] || '';
    } else if (url.hostname === 'youtu.be') {
      videoId = url.pathname.slice(1).split('?')[0] || '';
    } else {
      videoId = url.searchParams.get('v') || '';
    }
  } catch {
    videoId = '';
  }

  if (!videoId) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm"></div>
      <div
        className="relative w-full max-w-[400px] bg-neutral-900 border border-neutral-700 rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-neutral-800">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center bg-red-600 rounded-lg">
              <i className="ri-youtube-fill text-white text-sm"></i>
            </div>
            <p className="text-white font-bold text-sm">{studentName} 영상</p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-neutral-800 text-neutral-400 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        {/* Video */}
        <div className="relative w-full" style={{ aspectRatio: '9/16' }}>
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
            title={`${studentName} 유튜브 영상`}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

function TestimonialModal({
  isOpen,
  onClose,
  student,
}: {
  isOpen: boolean;
  onClose: () => void;
  student: StudentWithTestimonial | null;
}) {
  if (!isOpen || !student) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div
        className="relative bg-neutral-900 border border-neutral-700 rounded-2xl shadow-2xl w-full max-w-md max-h-[70vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-neutral-800">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-yellow-400/30 flex-shrink-0">
              <img src={student.image} alt={student.name} className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <p className="text-white font-bold text-sm">{student.name}</p>
              <p className="text-neutral-400 text-xs">{student.school}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-neutral-800 text-neutral-400 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Content */}
        <div className="px-5 py-5 overflow-y-auto max-h-[55vh]">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-double-quotes-l text-yellow-400/60 text-2xl"></i>
          </div>
          <p className="text-neutral-200 text-sm leading-relaxed whitespace-pre-line">
            {student.fullTestimonial}
          </p>
          <div className="flex justify-end mt-4">
            <i className="ri-double-quotes-r text-yellow-400/30 text-2xl"></i>
          </div>
          <div className="mt-4 pt-4 border-t border-neutral-800">
            <p className="text-yellow-400 text-xs font-semibold">
              {student.university || student.subject}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function StudentCardSlider({
  students,
  labelKey,
  altPrefix,
  onTestimonialClick,
  onYoutubeClick,
  onShowStudentList,
}: {
  students: SectionData['students'];
  labelKey: 'university' | 'subject';
  altPrefix: string;
  onTestimonialClick: (student: StudentWithTestimonial) => void;
  onYoutubeClick: (student: StudentWithTestimonial) => void;
  onShowStudentList?: () => void;
}) {
  const [current, setCurrent] = useState(0);
  const autoPlayRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const pauseTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  // 모바일 감지
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 모바일 자동 슬라이드
  useEffect(() => {
    if (!isMobile || students.length <= 1) return;

    const startAutoPlay = () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
      autoPlayRef.current = setInterval(() => {
        setCurrent((p) => (p === students.length - 1 ? 0 : p + 1));
      }, 3000);
    };

    startAutoPlay();

    return () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
      if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
    };
  }, [isMobile, students.length]);

  const pauseAndResume = () => {
    if (!isMobile) return;
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
    pauseTimeoutRef.current = setTimeout(() => {
      if (isMobile && students.length > 1) {
        autoPlayRef.current = setInterval(() => {
          setCurrent((p) => (p === students.length - 1 ? 0 : p + 1));
        }, 3000);
      }
    }, 5000);
  };

  const handlePrev = () => {
    setCurrent((p) => (p === 0 ? students.length - 1 : p - 1));
    pauseAndResume();
  };
  const handleNext = () => {
    setCurrent((p) => (p === students.length - 1 ? 0 : p + 1));
    pauseAndResume();
  };

  const label = (s: (typeof students)[0]) =>
    labelKey === 'university' ? (s as any).university : (s as any).subject;

  const currentStudent = students[current] as StudentWithTestimonial;

  // YouTube 링크 렌더링 헬퍼
  const renderYoutubeLink = (student: any) => {
    if (!student.youtubeUrl) return null;
    return (
      <button
        className="absolute bottom-3 right-3 z-[4] w-12 h-12 flex items-center justify-center bg-red-600 hover:bg-red-500 rounded-xl shadow-xl shadow-black/50 transition-all cursor-pointer group/yt hover:scale-110"
        onClick={(e) => {
          e.stopPropagation();
          onYoutubeClick(student as StudentWithTestimonial);
        }}
        title={`${student.name} 유튜브 영상 보기`}
      >
        <i className="ri-youtube-fill text-white text-2xl"></i>
      </button>
    );
  };

  // 섹션 2 여부 확인 (refund-50 섹션의 학생들인지)
  const isRefundSection = refundStudents.some(s => s.id === currentStudent.id);
  // 섹션 3 여부 확인 (discount-50 섹션의 학생들인지)
  const isDiscountSection = discountStudents.some(s => s.id === currentStudent.id);
  // 섹션 4 여부 확인 (top-free 섹션의 학생들인지)
  const isTopSection = topStudents.some(s => s.id === currentStudent.id);
  // 섹션 5 여부 확인 (honor-199 섹션의 학생들인지)
  const isHonorSection = honorStudents.some(s => s.id === currentStudent.id);
  // 섹션 6 여부 확인 (perfect-100 섹션의 학생들인지)
  const isPerfectSection = perfectStudents.some(s => s.id === currentStudent.id);

  const isNoTestimonialSection = isRefundSection || isDiscountSection || isTopSection || isHonorSection || isPerfectSection;

  return (
    <div className="relative w-full lg:w-[320px] xl:w-[360px]">
      {/* Card */}
      <div className="relative overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-900 shadow-2xl">
        {/* Image with overlay info */}
        <div className="relative w-full aspect-[3/4] overflow-hidden">
          <img
            src={currentStudent.image}
            alt={`${altPrefix} ${currentStudent.name}`}
            className="w-full h-full object-cover object-top"
          />
          {/* 그라디언트 오버레이 */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>

          {/* 사진 하단 오버레이: 라벨 + 이름 + 학교 */}
          <div className="absolute bottom-0 left-0 right-0 px-4 pb-5 pt-10">
            <p className="text-yellow-400 text-sm font-bold mb-2 leading-snug">
              {label(currentStudent)}
            </p>
            <div className="flex items-end justify-between">
              <div>
                <p className="text-white font-black text-xl leading-tight">{currentStudent.name}</p>
                <p className="text-neutral-200 text-sm mt-1">{currentStudent.school}</p>
              </div>
            </div>
          </div>

          {renderYoutubeLink(currentStudent)}
        </div>
      </div>

      {/* 후기 박스 - 독립 영역 */}
      {currentStudent.shortQuote && (
        <div className="mt-3 bg-yellow-400/10 border border-yellow-400/20 rounded-xl px-3 py-3">
          <p className="text-yellow-100 text-sm leading-relaxed line-clamp-3">
            {currentStudent.shortQuote}
          </p>
          {!isNoTestimonialSection && currentStudent.fullTestimonial && (
            <button
              onClick={() => onTestimonialClick(currentStudent)}
              className="mt-2 text-yellow-400 text-xs font-medium hover:text-yellow-300 transition-colors cursor-pointer"
            >
              더 보기 →
            </button>
          )}
        </div>
      )}

      {/* Navigation & Dots */}
      <div className="flex items-center justify-between mt-3 px-1">
        <button
          onClick={handlePrev}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 text-neutral-400 hover:text-white transition-all cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>

        <div className="flex items-center gap-1.5">
          {students.map((_, idx) => (
            <button
              key={idx}
              onClick={() => { setCurrent(idx); pauseAndResume(); }}
              className={`rounded-full transition-all cursor-pointer ${
                idx === current
                  ? 'w-4 h-1.5 bg-yellow-400'
                  : 'w-1.5 h-1.5 bg-neutral-700 hover:bg-neutral-500'
              }`}
            />
          ))}
        </div>

        <button
          onClick={handleNext}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 text-neutral-400 hover:text-white transition-all cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      </div>

      {/* 장학생 명단 보기 - mobile only */}
      {onShowStudentList && (
        <button
          onClick={onShowStudentList}
          className="mt-3 w-full flex lg:hidden items-center justify-center gap-1.5 px-4 py-2.5 bg-yellow-400 text-black text-sm font-semibold rounded-full hover:bg-yellow-300 transition-all cursor-pointer"
        >
          <i className="ri-group-line text-sm"></i>
          장학생 명단 보기
        </button>
      )}
    </div>
  );
}

function StudentListModal({
  isOpen,
  onClose,
  section,
}: {
  isOpen: boolean;
  onClose: () => void;
  section: SectionData | null;
}) {
  if (!isOpen || !section) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div
        className="relative bg-neutral-900 border border-neutral-700 rounded-2xl shadow-2xl w-full max-w-md max-h-[70vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-neutral-800">
          <div className="flex items-center gap-2">
            <span className="px-2.5 py-1 bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-sm font-medium rounded">
              {section.tag}
            </span>
            <h4 className="text-white font-bold text-sm">장학생 명단</h4>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-neutral-800 text-neutral-400 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Student List */}
        <div className="px-5 py-4 overflow-y-auto max-h-[55vh]">
          <ul className="space-y-3">
            {section.students.map((student, idx) => {
              const label =
                section.labelKey === 'university'
                  ? (student as any).university
                  : (student as any).subject;
              return (
                <li
                  key={student.id}
                  className="flex items-start gap-3 text-sm"
                >
                  <span className="w-5 h-5 flex-shrink-0 rounded-full bg-yellow-400/10 text-yellow-400 text-xs font-bold flex items-center justify-center mt-0.5">
                    {idx + 1}
                  </span>
                  <div>
                    <p className="text-white font-medium leading-snug">
                      {label}
                    </p>
                    <p className="text-neutral-400 text-xs mt-0.5">
                      {student.name} ({student.school})
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default function ScholarshipPage() {
  const [activeTab, setActiveTab] = useState(0);
  const tabContainerRef = useRef<HTMLDivElement>(null);
  const isClickScrolling = useRef(false);
  const [modalSection, setModalSection] = useState<SectionData | null>(null);
  const [testimonialStudent, setTestimonialStudent] = useState<StudentWithTestimonial | null>(null);
  const [youtubeStudent, setYoutubeStudent] = useState<StudentWithTestimonial | null>(null);

  const tabs = [
    {
      label: '장학금 100만원 지급',
      mobileLabel: ['장학금', '100만원 지급'],
      id: 'scholarship-100',
    },
    {
      label: '수능 1등급 50% 환급',
      mobileLabel: ['수능 1등급', '50% 환급'],
      id: 'refund-50',
    },
    {
      label: '전 과목 1등급 50% 할인',
      mobileLabel: ['전 과목 1등급', '50% 할인'],
      id: 'discount-50',
    },
    {
      label: '전교1등 무료수강',
      mobileLabel: ['전교1등', '무료수강'],
      id: 'top-free',
    },
    {
      label: '내신 199 50% 할인',
      mobileLabel: ['내신 199', '50% 할인'],
      id: 'honor-199',
    },
    {
      label: '전과목 100점 전액 면제',
      mobileLabel: ['전과목 100점', '전액 면제'],
      id: 'perfect-100',
    },
  ];

  const scrollToSection = useCallback((id: string, index: number) => {
    const el = document.getElementById(id);
    if (el) {
      setActiveTab(index);
      isClickScrolling.current = true;
      const navHeight = 72;
      const tabBarHeight = 56;
      const extraPadding = 24;
      const top =
        el.getBoundingClientRect().top +
        window.scrollY -
        navHeight -
        tabBarHeight -
        extraPadding;
      window.scrollTo({ top, behavior: 'instant' as const });
      setTimeout(() => {
        isClickScrolling.current = false;
      }, 100);
    }
  }, []);

  // Ensure the page starts at the top on mount
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
    
    // Set page title and meta tags
    document.title = '미래인재학원 장학 제도 - 민락, 옥정, 지행 학원 장학금';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '🏆 100만원 장학금! 서울대·연고대·의대 합격 시 지급, 수능 1등급 50% 환급, 전교 1등 무료 수강 등 다양한 장학 혜택.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 장학 제도 - 민락, 옥정, 지행 학원 장학금');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '🏆 100만원 장학금! 서울대·연고대·의대 합격 시 지급, 수능 1등급 50% 환급, 전교 1등 무료 수강 등 다양한 장학 혜택.');
    }
  }, []);

  // Observe sections to update active tab
  useEffect(() => {
    const sectionIds = tabs.map((t) => t.id);
    const observers: IntersectionObserver[] = [];

    sectionIds.forEach((id, index) => {
      const el = document.getElementById(id);
      if (!el) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isClickScrolling.current) {
              setActiveTab(index);
            }
          });
        },
        { rootMargin: '-160px 0px -50% 0px', threshold: 0 },
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => {
      observers.forEach((o) => o.disconnect());
    };
  }, [tabs]);

  // Keep the selected tab button in view
  useEffect(() => {
    if (tabContainerRef.current) {
      const activeButton = tabContainerRef.current.children[
        activeTab
      ] as HTMLElement;
      if (activeButton) {
        activeButton.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  }, [activeTab]);

  const topFreeStudents = [
    {
      name: '권윤택',
      school: '옥정고 2학년',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20confident%20Korean%20high%20school%20male%20student%20in%20school%20uniform%20with%20a%20warm%20smile%20against%20a%20clean%20white%20studio%20background%20with%20soft%20natural%20lighting%20creating%20a%20bright%20and%20positive%20atmosphere&width=260&height=320&seq=kwon-yuntaek-scholarship-student-portrait&orientation=portrait',
      shortQuote: '학원에 다니며 학습 계획을 꾸준히 유지하고 스스로 공부하는 습관을 기를 수 있어서 좋았습니다',
      fullTestimonial: '학원에 다니며 학습 계획을 꾸준히 유지하고 스스로 공부하는 습관을 기를 수 있어서 좋았습니다'
    },
    {
      name: '홍단샘',
      school: '옥정고 2학년',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20confident%20Korean%20high%20school%20female%20student%20in%20school%20uniform%20with%20a%20warm%20smile%20against%20a%20clean%20white%20studio%20background%20with%20soft%20natural%20lighting%20creating%20a%20bright%20and%20positive%20atmosphere&width=260&height=320&seq=hong-dansaem-scholarship-student-portrait&orientation=portrait',
      shortQuote: '미래인재학원만이 가지는 체계적인 관리와 시스템은 정말 큰 장점이라고 생각합니다. 개인의 의지만 충분하다면 성적을 올리는 데 있어서 큰 도움이 되는 거 같습니다',
      fullTestimonial: '미래인재학원만이 가지는 체계적인 관리와 시스템은 정말 큰 장점이라고 생각합니다. 개인의 의지만 충분하다면 성적을 올리는 데 있어서 큰 도움이 되는 거 같습니다'
    },
    {
      name: '강지호',
      school: '옥정고 2학년',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20confident%20Korean%20high%20school%20male%20student%20in%20school%20uniform%20with%20a%20warm%20smile%20against%20a%20clean%20white%20studio%20background%20with%20soft%20natural%20lighting%20creating%20a%20bright%20and%20positive%20atmosphere&width=260&height=320&seq=kang-jiho-scholarship-student-portrait&orientation=portrait',
      shortQuote: '',
      fullTestimonial: ''
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <Navigation currentPage="about" />

      {/* Hero Section */}
      <section className="relative min-h-[600px] flex items-center overflow-hidden bg-neutral-950">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/15 via-yellow-500/5 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/80 to-neutral-950/60"></div>
        </div>

        <div className="absolute top-20 right-1/4 w-80 h-80 bg-yellow-400/10 rounded-full blur-3xl -translate-y-1/3"></div>
        <div className="absolute bottom-20 left-1/4 w-60 h-60 bg-yellow-400/[0.02] rounded-full blur-3xl translate-y-1/3"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
            <span className="inline-block px-4 py-2 bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-sm font-medium rounded-full mb-6">
              Scholarship Benefits
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              미래인재학원<br />
              <span className="text-yellow-400">장학 제도</span> 안내
            </h1>
            <p className="text-base md:text-xl text-neutral-300 leading-relaxed mb-8">
              노력하는 학생들에게 더 큰 기회를 제공합니다.<br />
              미래인재학원은 우수한 성적과 성실한 학습 태도를 가진
              <br className="hidden md:block" />
              학생들을 위한 다양한 장학 프로그램을 운영하고 있습니다.
            </p>
          </div>
        </div>
      </section>

      {/* Sticky Tab Navigation */}
      <div className="sticky top-[72px] z-40 bg-black/95 backdrop-blur-xl border-b border-yellow-400/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Desktop tabs */}
          <div
            ref={tabContainerRef}
            className="hidden lg:flex items-center justify-center gap-0 py-2"
          >
            {tabs.map((tab, index) => (
              <button
                key={tab.id}
                onClick={() => scrollToSection(tab.id, index)}
                className={`relative flex-1 px-2 py-2.5 text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer text-center rounded-full mx-0.5 ${
                  activeTab === index
                    ? 'bg-yellow-400 text-black shadow-lg shadow-yellow-400/20'
                    : 'text-neutral-400 hover:text-white hover:bg-neutral-800'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {/* Mobile tabs */}
          <div className="grid grid-cols-3 gap-1.5 py-2 lg:hidden">
            {tabs.map((tab, index) => (
              <button
                key={tab.id}
                onClick={() => scrollToSection(tab.id, index)}
                className={`px-1.5 py-2.5 text-xs font-medium transition-all duration-300 cursor-pointer text-center rounded-lg leading-tight ${
                  activeTab === index
                    ? 'bg-yellow-400 text-black shadow-lg shadow-yellow-400/20'
                    : 'text-neutral-400 hover:text-white bg-neutral-800/50'
                }`}
              >
                <span className="block">{tab.mobileLabel[0]}</span>
                <span className="block">{tab.mobileLabel[1]}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Scholarship Sections */}
      {sections.map((section, sectionIndex) => {
        const isEven = sectionIndex % 2 === 0;
        return (
          <section
            key={section.id}
            id={section.id}
            className={`relative py-28 overflow-hidden ${
              isEven ? 'bg-neutral-950' : 'bg-neutral-900/50'
            }`}
          >
            {/* Decorative elements */}
            <div
              className={`absolute top-0 ${
                isEven ? 'right-0' : 'left-0'
              } w-[500px] h-[500px] bg-yellow-400/[0.03] rounded-full blur-3xl -translate-y-1/2 ${
                isEven ? 'translate-x-1/4' : '-translate-x-1/4'
              }`}
            ></div>
            <div
              className={`absolute bottom-0 ${
                isEven ? 'left-0' : 'right-0'
              } w-72 h-72 bg-yellow-400/[0.02] rounded-full blur-3xl translate-y-1/3`}
            ></div>

            {/* Subtle grid pattern */}
            <div
              className="absolute inset-0 opacity-[0.02]"
              style={{
                backgroundImage:
                  'radial-gradient(circle, #fbbf24 1px, transparent 1px)',
                backgroundSize: '48px 48px',
              }}
            ></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              <div
                className="flex flex-col lg:flex-row items-center lg:items-stretch gap-6 lg:gap-2"
              >
                {/* Text */}
                <div className="flex-1 w-full flex flex-col">
                  <div className="flex items-center gap-4 mb-8">
                    <span className="text-6xl md:text-7xl font-black text-yellow-400/70 leading-none select-none">
                      {section.number}
                    </span>
                    <span className="inline-block px-4 py-1.5 bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-xs font-semibold rounded-tracking-wide">
                      {section.tag}
                    </span>
                  </div>

                  <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-6">
                    {section.title}
                  </h3>

                  <div className="flex items-center gap-2 mb-8">
                    <div className="w-12 h-1 bg-yellow-400 rounded-full"></div>
                    <div className="w-3 h-1 bg-yellow-400/40 rounded-full"></div>
                    <div className="w-1.5 h-1 bg-yellow-400/20 rounded-full"></div>
                  </div>

                  <p className="text-lg md:text-xl text-neutral-300 leading-relaxed">
                    {section.description}
                  </p>

                  <button
                    onClick={() => {
                      setModalSection(section);
                    }}
                    className="mt-5 hidden lg:inline-flex items-center gap-1.5 px-4 py-2 bg-yellow-400 text-black text-sm font-semibold rounded-full hover:bg-yellow-300 transition-all cursor-pointer whitespace-nowrap self-start"
                  >
                    <i className="ri-group-line text-sm"></i>
                    장학생 명단 보기
                  </button>

                  <div className="mt-auto pt-4">
                    <div className="flex items-center gap-4 p-4 bg-neutral-900/80 border border-neutral-800 rounded-xl lg:max-w-[66%]">
                      <div className="w-10 h-10 rounded-lg bg-yellow-400/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${section.noteIcon} text-yellow-400 text-lg`}></i>
                      </div>
                      <p className="text-sm text-neutral-400 leading-relaxed pt-1.5">
                        {section.noteText}
                      </p>
                    </div>
                    {/* Spacer to align with dot indicators on slider side */}
                    <div className="hidden lg:block h-[22px]"></div>
                  </div>
                </div>

                {/* Slider */}
                <div className="w-full lg:w-auto flex flex-col justify-end items-center lg:items-end flex-shrink-0">
                  <div id={`slider-${section.id}`}>
                    <StudentCardSlider
                      students={section.students}
                      labelKey={section.labelKey}
                      altPrefix={section.tag}
                      onTestimonialClick={(student) => setTestimonialStudent(student)}
                      onYoutubeClick={(student) => setYoutubeStudent(student)}
                      onShowStudentList={() => setModalSection(section)}
                    />
                  </div>
                </div>

                {/* Mobile only: 장학생 명단 보기 button below slider - REMOVED (now inside StudentCardSlider) */}
              </div>
            </div>

            {/* Bottom divider */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-7xl px-4">
              <div className="h-px bg-gradient-to-r from-transparent via-yellow-400/15 to-transparent"></div>
            </div>
          </section>
        );
      })}

      <StudentListModal
        isOpen={!!modalSection}
        onClose={() => setModalSection(null)}
        section={modalSection}
      />
      <TestimonialModal
        isOpen={!!testimonialStudent}
        onClose={() => setTestimonialStudent(null)}
        student={testimonialStudent}
      />
      <YouTubeModal
        isOpen={!!youtubeStudent}
        onClose={() => setYoutubeStudent(null)}
        youtubeUrl={youtubeStudent?.youtubeUrl || ''}
        studentName={youtubeStudent?.name || ''}
      />
      <Footer />
    </div>
  );
}
